export const comments_4088336 = {"data":{"data":[],"links":{}}}